import role, { RoleState } from './roles/role.store';

export interface UserState {
   role?: RoleState;
}

const state: UserState = {};

const getters = {};

const mutations = {};

const actions = {};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
   modules: {
      role,
   },
};
